export enum TransportFilterName {
  TransportOrderNumbers = 'transportOrderNumbers',
  LoadNumbers = 'loadNumbers',
  MaterialNumbers = 'materialNumbers',
  DeliveryNoteNumbers = 'deliveryNoteNumbers',
  HouseAirwayBills = 'houseAirwayBills',
  IStarNumbers = 'iStarNumbers',
  TransportModes = 'transportModes',
  Origins = 'origins',
  Regions = 'regions',
  Statuses = 'statuses',
  FreightModes = 'freightModes',
  ServiceLevels = 'serviceLevels',
  DeliveryServices = 'deliveryServices',
  Carriers = 'carriers',
  Pickups = 'pickups',
  ShipTos = 'shipTos',
  Consignors = 'consignors',
  Consignees = 'consignees',
  EstimatedDepartureTime = 'estimatedDepartureTime',
  EstimatedArrivalTime = 'estimatedArrivalTime',
  ActualDepartureTime = 'actualDepartureTime',
  ActualArrivalTime = 'actualArrivalTime',
  PlannedDepartureTime = 'plannedDepartureTime',
  PlannedArrivalTime = 'plannedArrivalTime',
  ReasonCodes = 'reasonCodes',
  StatusCodes = 'statusCodes',
  TruckPlates = 'truckPlates',
  TrailerPlates = 'trailerPlates',
  FlightNumbers = 'flightNumbers',
  VesselNames = 'vesselNames',
  DeviationTypes = 'deviationTypes',
  DeviationHours = 'deviationHours',
}

export enum ArrivalsDepartureGroupsName {
  EstimatedDepartureTime = 'estimatedDepartureTime',
  EstimatedArrivalTime = 'estimatedArrivalTime',
  ActualDepartureTime = 'actualDepartureTime',
  ActualArrivalTime = 'actualArrivalTime',
  PlannedDepartureTime = 'plannedDepartureTime',
  PlannedArrivalTime = 'plannedArrivalTime',
}
